import React, { useState, useEffect } from 'react';
import homeFoto from '../images/home-foto.jpg';
import { Link } from 'react-router-dom';

function Home() {
  const texts = [
    "ZEMİN ETÜT",
    "ZEMİN İYİLEŞTİRME",
    "GEOTEKNİK PROJE"
  ];

  const [currentText, setCurrentText] = useState(texts[0]);
  const [fadeOut, setFadeOut] = useState(false);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true); // Yazıyı silme efekti

      setTimeout(() => {
        setTextIndex((prevIndex) => (prevIndex + 1) % texts.length); // Sonraki yazıya geçiş
        setCurrentText(texts[(textIndex + 1) % texts.length]);
        setFadeOut(false); // Yeni yazıyı ekleme efekti
      }, 500); // Silme efekti süresi

    }, 4000); // Yazı başına toplam süre

    return () => clearInterval(interval);
  }, [textIndex, texts]);

  return (
    <div>
      {/* Hero Section */}
      <div
        className="h-screen relative bg-cover bg-center"
        style={{
          backgroundImage: `url(${homeFoto})`,
          backgroundBlendMode: "overlay",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        }}
      >
        <div className="container mx-auto px-4 h-[calc(100vh-200px)] flex flex-col items-center justify-center relative">
          <div className="text-white text-center" style={{ width: "80%" }}>
            {/* Dynamic Text Animation */}
            <h1
              className={`text-5xl sm:text-4xl md:text-3xl lg:text-5xl xl:text-6xl font-bold mb-6 text-center transition-opacity duration-500 ${
                fadeOut ? "opacity-0" : "opacity-100"
              }`}
              style={{
                fontWeight: "bold",
                lineHeight: "1.3", // Satır aralığını genişletiyoruz
              }}
            >
              {currentText}
            </h1>
          </div>

          {/* Fixed Button */}
          <div
            className="absolute bottom-10 flex justify-center"
            style={{
              width: "100%",
            }}
          >
            <Link
              to="hakkimizda"
              className="px-12 py-4 text-lg rounded-lg font-semibold border border-white text-white bg-transparent transition-all duration-300 hover:bg-white hover:text-gray-900"
            >
              Kurumsal
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
